import dayjs from "dayjs";
import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ToggleButton from "react-toggle-button";
import SimpleButton from "../../../modules/commons/SimpleButton";
import withFormGroup from "../../../modules/commons/withFormGroup";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDate from "../../../modules/SimpleDate";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleInputPassword from "../../../modules/SimpleInputPassword";
import SimpleTextArea from "../../../modules/simpleTextArea";
import SimpleUploadImage from "../../../modules/upload/SimpleUploadImage";
import Api from "../../../Services/Api";
import {ACTIVITY_TYPE, Level, Status} from "../../common/Constants";
import {mapToObjectDDL} from "../../common/mapper";

class MasterUserModifying extends Component {
    constructor(props) {
        super(props);
        this.isAdmin = this.props.username === "admin";
        this.state = {
            loading: false,
            provinceOptions: [],
            genderOptions: [],
            religionOptions: [],
            kotaOptions: [],
            kecamatanOptions: [],
            kelurahanOptions: [],
            aksesCabangOptions: [],
            hirarkiOptions: [],
            aksesMenuOptions: [],
        };
    }

    async componentDidMount() {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const userId = localStorage.getItem("userId");
        const responses = await Promise.all([
            Api.create("NAGAMAS_MASTER_DATA").getAllProvince(),
            Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
                paramFilters: {
                    bizparCategory: "RELIGION_TYPE",
                    status: Status.ACTIVE,
                },
            }),
            Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
                paramFilters: {
                    bizparCategory: "GENDER_TYPE",
                },
            }),
            Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang(),
            Api.create("NAGAMAS_MASTER_DATA").getAllHirarki(),
            Api.create("NAGAMAS_AUTH").getDropDownListMenuForMasterUser({
                idUser: userId
            }),
        ]);

        if (responses[0].ok && !R.isEmpty(responses[0].data.data)) {
            this.setOptionsData("provinceOptions", responses[0].data.data);
        }

        if (responses[1].ok && !R.isEmpty(responses[1].data.data)) {
            this.setOptionsData("religionOptions", responses[1].data.data);
        }

        if (responses[2].ok && !R.isEmpty(responses[2].data.data)) {
            this.setOptionsData("genderOptions", responses[2].data.data);
        }

        if (responses[3].ok && !R.isEmpty(responses[3].data.data)) {
            this.setOptionsData("aksesCabangOptions", responses[3].data.data);
        }

        if (responses[4].ok && !R.isEmpty(responses[4].data.data)) {
            this.setOptionsData("hirarkiOptions", responses[4].data.data);
        }

        if (responses[5].ok && !R.isEmpty(responses[5].data.data)) {
            this.setOptionsData("aksesMenuOptions", responses[5].data.data);
        }

        if (R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)) {
            const controls = this.props.controls;
            if (!R.isNil(controls.province.value)) {
                this.fetchKotaOptions(controls.province.value.value);
            }

            if (!R.isNil(controls.kabKot.value)) {
                this.fetchKecamatanOptions(controls.kabKot.value.value);
            }

            if (!R.isNil(controls.kecamatan.value)) {
                this.fetchKelurahanOptions(controls.kecamatan.value.value);
            }

            const hirarkiValue = this.state.hirarkiOptions.find((h) => h.id === controls.hirarki.value);
            this.props.setValue("hirarki", hirarkiValue);
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    }

    setOptionsData = (key, data) => {
        let optionsData;
        if (R.equals(key, "provinceOptions")) {
            optionsData = data.map((value) => mapToObjectDDL(value.provinceName, value.id));
        } else if (R.equals(key, "aksesCabangOptions")) {
            optionsData = data.map((value) => mapToObjectDDL(value.namaDealer, value.kodeCabang));
        } else if (R.equals(key, "hirarkiOptions")) {
            optionsData = data.map((value) => ({...value, label: value.roleName, value: value.id}));
        } else if (R.equals(key, "aksesMenuOptions")) {
            optionsData = data.map((value) => mapToObjectDDL(value.roleName, value.id));
        } else {
            optionsData = data.map((value) => mapToObjectDDL(value.value, value.key));
        }

        this.setState((prevValue) => ({
            ...prevValue,
            [key]: optionsData,
        }));
    };

    fetchKotaOptions = async (id) => {
        const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(id);
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                kotaOptions: response.data.data.map((option) =>
                    mapToObjectDDL(option.kabKotName, option.kabKotId)
                ),
            }));
        }
    };

    fetchKecamatanOptions = async (id) => {
        const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(id);
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                kecamatanOptions: response.data.data.map((option) =>
                    mapToObjectDDL(option.kecamatanName, option.id)
                ),
            }));
        }
    };

    fetchKelurahanOptions = async (id) => {
        const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(id);
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                kelurahanOptions: response.data.data.map((option) => ({
                    ...mapToObjectDDL(`${option.zipcode} - ${option.kelurahanname}`, option.zipcode),
                    kelurahanId: option.id,
                })),
            }));
        }
    };

    handleChangeProvince = async (name, value) => {
        this.props.setValue("kabKot", null);
        this.props.setValue("kecamatan", null);
        this.props.setValue("zipCode", null);
        this.props.setValue(name, value);
        if (!R.isNil(value)) {
            this.fetchKotaOptions(value.value);
        }
    };

    handleChangeKota = async (name, value) => {
        this.props.setValue("kecamatan", null);
        this.props.setValue("zipCode", null);
        this.props.setValue(name, value);
        if (!R.isNil(value)) {
            this.fetchKecamatanOptions(value.value);
        }
    };

    handleChangeKecamatan = async (name, value) => {
        this.props.setValue("zipCode", null);
        this.props.setValue(name, value);
        if (!R.isNil(value)) {
            this.fetchKelurahanOptions(value.value);
        }
    };

    handleSubmit = () => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    handleTextChange = ({target}) => {
        this.props.setValue(target.name, target.value);
    };

    handleDDLChange = (value, {name}) => {
        this.props.setValue(name, value);
    };

    handleResignDateChange = (value) => {
        if (
            !R.isNil(this.props.controls.tanggalMasuk) &&
            dayjs(value).isBefore(this.props.controls.tanggalMasuk.value)
        ) {
            this.props.setValue("tanggalResign", value);
            this.props.setValue("tanggalMasuk", value);
        } else {
            this.props.setValue("tanggalResign", value);
        }
    };

    handleGenerateUsername = async () => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const name = this.props.controls.name.value || "";
        const response = await Api.create("NAGAMAS_AUTH").generateUsername({name});
        this.props.setValue("username", response.data.data);
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    render() {
        return (
            <>
                <SimpleModal
                    title="Master Users"
                    visible={this.props.visible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <div style={{padding: "1rem 2rem"}}>
                            <div className="padding-15px grid grid-2x grid-mobile-none gap-15px">
                                {this.renderForm()}
                                {this.renderForm1()}
                            </div>
                            <FlexView hAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton type="button" onClick={this.handleSubmit}>
                                    Simpan
                                </SimpleButton>
                                <SimpleButton type="button" secondary onClick={() => this.props.reset()}>
                                    Clear
                                </SimpleButton>
                            </FlexView>
                        </div>
                    }
                />
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }

    renderForm() {
        return (
            <div>
                <h4>DATA KARYAWAN</h4>
                <SimpleInput
                    id="input_text_nama"
                    name="name"
                    label="Nama"
                    mandatory
                    errorMessage={this.props.errors.name}
                    value={this.props.controls.name.value}
                    onChange={this.handleTextChange}
                />
                <SimpleInput
                    id="input_text_nikkaryawan"
                    name="nik"
                    label="NIK Karyawan"
                    box="onlyNumber"
                    mandatory
                    errorMessage={this.props.errors.nik}
                    value={this.props.controls.nik.value}
                    onChange={this.handleTextChange}
                />
                <SimpleInput
                    id="input_text_noktp"
                    name="ktpNumber"
                    label="No. KTP"
                    box="onlyNumber"
                    mandatory
                    errorMessage={this.props.errors.ktpNumber}
                    maxLength={16}
                    value={this.props.controls.ktpNumber.value}
                    onChange={this.handleTextChange}
                />
                <SimpleInput
                    id="input_text_nohp"
                    name="hpnumber"
                    label="No. HP"
                    box="onlyNumber"
                    maxLength={14}
                    value={this.props.controls.hpnumber.value}
                    onChange={this.handleTextChange}
                />
                <SimpleInput
                    id="input_text_email"
                    name="email"
                    label="Email"
                    type="email"
                    value={this.props.controls.email.value}
                    onChange={this.handleTextChange}
                />
                <SimpleDDL
                    id="select_options_agama"
                    box="search"
                    label="Agama"
                    name="religion"
                    isClearable
                    options={this.state.religionOptions}
                    value={this.props.controls.religion.value}
                    onChange={this.handleDDLChange}
                />
                <SimpleDate
                    id="select_date_tanggal_lahir"
                    label="Tanggal Lahir"
                    nextdate
                    date={this.props.controls.birthDate.value}
                    onChange={(value) => this.props.setValue("birthDate", value)}
                />
                <SimpleDDL
                    id="select_options_agama"
                    box="search"
                    label="Jenis Kelamin"
                    name="gender"
                    isClearable
                    options={this.state.genderOptions}
                    value={this.props.controls.gender.value}
                    onChange={this.handleDDLChange}
                />
                <SimpleInput
                    id="input_text_nonpwp"
                    name="npwpNumber"
                    label="No. NPWP"
                    box="onlyNumber"
                    value={this.props.controls.npwpNumber.value}
                    onChange={this.handleTextChange}
                />
                <SimpleInput
                    id="input_text_status_pajak"
                    name="taxStatus"
                    label="Status Pajak"
                    value={this.props.controls.taxStatus.value}
                    onChange={this.handleTextChange}
                />
                <SimpleInput
                    id="input_text_nobpjskes"
                    name="bpjsNumber"
                    label="No. BPJS Kes."
                    box="onlyNumber"
                    value={this.props.controls.bpjsNumber.value}
                    onChange={this.handleTextChange}
                />
                <SimpleInput
                    id="input_text_nobpjsket"
                    name="bpjsTkNumber"
                    label="No. BPJS Ket."
                    box="onlyNumber"
                    value={this.props.controls.bpjsTkNumber.value}
                    onChange={this.handleTextChange}
                />
                <SimpleTextArea
                    id="input_text_alamat"
                    typeInputCase="normal"
                    name="address"
                    label="Alamat"
                    value={this.props.controls.address.value}
                    onChange={this.handleTextChange}
                />
                <SimpleDDL
                    id="select_options_provinsi"
                    box="search"
                    label="Provinsi"
                    name="province"
                    isClearable
                    options={this.state.provinceOptions}
                    value={this.props.controls.province.value}
                    onChange={(value, {name}) => this.handleChangeProvince(name, value)}
                />
                <SimpleDDL
                    id="select_options_kota"
                    box="search"
                    label="Kota"
                    name="kabKot"
                    isClearable
                    readOnly={R.isNil(this.props.controls.province.value)}
                    options={this.state.kotaOptions}
                    value={this.props.controls.kabKot.value}
                    onChange={(value, {name}) => this.handleChangeKota(name, value)}
                />
                <SimpleDDL
                    id="select_options_kecamatan"
                    box="search"
                    label="Kecamatan"
                    name="kecamatan"
                    isClearable
                    readOnly={R.isNil(this.props.controls.kabKot.value)}
                    options={this.state.kecamatanOptions}
                    value={this.props.controls.kecamatan.value}
                    onChange={(value, {name}) => this.handleChangeKecamatan(name, value)}
                />
                <SimpleDDL
                    id="select_options_kode_pos"
                    box="search"
                    label="Kode Pos"
                    name="zipCode"
                    isClearable
                    readOnly={R.isNil(this.props.controls.kecamatan.value)}
                    options={this.state.kelurahanOptions}
                    value={this.props.controls.zipCode.value}
                    onChange={this.handleDDLChange}
                />
                <SimpleDate
                    id="select_date_tanggal_masuk"
                    label="Tgl. Masuk"
                    nextdate
                    date={this.props.controls.tanggalMasuk.value}
                    maxDate={this.props.controls.tanggalResign.value || new Date()}
                    onChange={(value) => this.props.setValue("tanggalMasuk", value)}
                />
                <SimpleDate
                    id="select_date_tanggal_resign"
                    label="Tgl. Resign"
                    nextdate
                    date={this.props.controls.tanggalResign.value}
                    onChange={(value) => this.handleResignDateChange(value)}
                />
                <SimpleUploadImage
                    id="input_upload_foto_ktp"
                    name="ktpPhoto"
                    label="Foto KTP"
                    value={this.props.controls.ktpPhoto.value}
                    onChange={(value, name) => this.props.setValue(name, value)}
                />
            </div>
        );
    }

    renderForm1() {
        return (
            <div>
                <h4>HAK AKSES</h4>
                <SimpleDDL
                    id="select_options_hirarki"
                    box="search"
                    label="Hirarki"
                    name="hirarki"
                    mandatory
                    options={this.state.hirarkiOptions}
                    errorMessage={this.props.errors.hirarki}
                    value={this.props.controls.hirarki.value}
                    onChange={(value, {name}) => {
                        this.props.setValue(name, value);
                        this.props.setValue("ahassLine", Level[value.ahasLine]);
                        this.props.setValue("marketingLine", Level[value.mktLine]);
                        this.props.setValue("administrationLine", Level[value.adminLine]);
                    }}
                />
                <SimpleDDL
                    id="select_options_line_akses"
                    box="search"
                    label="Line Ahass"
                    name="ahassLine"
                    mandatory
                    options={Level}
                    readOnly={!this.isAdmin}
                    errorMessage={this.props.errors.ahassLine}
                    value={this.props.controls.ahassLine.value}
                    onChange={this.handleDDLChange}
                />
                <SimpleDDL
                    id="select_options_line_marketing"
                    box="search"
                    label="Line Marketing"
                    name="marketingLine"
                    mandatory
                    options={Level}
                    readOnly={!this.isAdmin}
                    errorMessage={this.props.errors.marketingLine}
                    value={this.props.controls.marketingLine.value}
                    onChange={this.handleDDLChange}
                />
                <SimpleDDL
                    id="select_options_line_administrasi"
                    box="search"
                    label="Line Administrasi"
                    name="administrationLine"
                    mandatory
                    options={Level}
                    readOnly={!this.isAdmin}
                    errorMessage={this.props.errors.administrationLine}
                    value={this.props.controls.administrationLine.value}
                    onChange={this.handleDDLChange}
                />
                <SimpleUploadImage
                    id="input_upload_foto_wajah"
                    name="employeePhoto"
                    shape="circle"
                    label="Foto Wajah"
                    value={this.props.controls.employeePhoto.value}
                    onChange={(value, name) => this.props.setValue(name, value)}
                />
                <SimpleUploadImage
                    id="input_upload_tanda_tangan"
                    name="signPhoto"
                    label="Tanda Tangan"
                    value={this.props.controls.signPhoto.value}
                    onChange={(value, name) => this.props.setValue(name, value)}
                />
                <SimpleDDL
                    id="select_options_hak_akses_cabang"
                    box="multiselect"
                    label="Hak Akses Cabang"
                    name="idrefobj"
                    mandatory
                    readOnly={this.props.actionType === 'correction'}
                    options={this.state.aksesCabangOptions}
                    errorMessage={this.props.errors.idrefobj}
                    value={this.props.controls.idrefobj.value}
                    onChange={this.handleDDLChange}
                />
                <SimpleDDL
                    id="select_options_hak_akses_menu"
                    box="search"
                    label="Hak Akses Menu"
                    name="idrole"
                    mandatory
                    readOnly={this.props.actionType === 'correction'}
                    options={this.state.aksesMenuOptions}
                    errorMessage={this.props.errors.idrole}
                    value={this.props.controls.idrole.value}
                    onChange={this.handleDDLChange}
                />
                <FlexView vAlignContent="center">
                    <SimpleInput
                        containerclassname="flex-3"
                        id="input_text_username"
                        name="username"
                        label="Set Username"
                        mandatory
                        readOnly={this.props.actionType === 'correction'}
                        errorMessage={this.props.errors.username}
                        value={this.props.controls.username.value}
                        onChange={this.handleTextChange}
                    />
                    <SimpleButton
                        className="margin-top-5px flex-1"
                        type="button"
                        onClick={this.handleGenerateUsername}
                    >
                        Generate Username
                    </SimpleButton>
                </FlexView>
                <SimpleInputPassword
                    id="input_text_password"
                    name="password"
                    label="Set Password"
                    mandatory={R.equals(this.props.activityType, ACTIVITY_TYPE.CREATE)}
                    required={false}
                    readOnly={this.props.actionType === 'correction'}
                    errorMessage={this.props.errors.password}
                    value={this.props.controls.password.value}
                    onChange={this.handleTextChange}
                />
                <div className="margin-top-15px"/>
                <ToggleButton
                    id="input_switch_status"
                    value={R.equals(this.props.controls.status.value, Status.ACTIVE)}
                    onToggle={(value) =>
                        this.props.setValue("status", !value ? Status.ACTIVE : Status.INACTIVE)
                    }
                />
            </div>
        );
    }
}

export default withFormGroup(MasterUserModifying);
